import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';

import { Container, Items, Item, Icon, IconContainer } from './styles';
import { PaymentCard } from 'models/paymentCard';


interface Props {
  show: boolean;
  value: PaymentCard;
  cards: PaymentCard[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: PaymentCard) => void;
  onClose: () => void;
  testId?: string;
}

interface MakeItemProps {
  className: string;
  type: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, type, ...rest }: MakeItemProps) => {
  const getCardIcon = (cardType: string) => {
    switch (cardType) {
      case 'visa':
        return '/corporate/images/payment/cc/visa.svg';
      case 'master':
        return '/corporate/images/payment/cc/mastercard.svg';
      case 'amex':
        return '/corporate/images/payment/cc/amex.svg';
      default:
        return '/corporate/images/payment/payment-card-default.svg';
    }
  }
  return (
    <>
          <IconContainer>
        <Icon src={getCardIcon(type)} />
        <Item 
      {...rest}>{text}
      </Item>
      </IconContainer>
    </>

  )
}

const CardSelect = ({ show, cards, selectRef, value, onChange, onClose, testId }: Props) => {
  useOutsideClick(selectRef, onClose);
  const isActive = useCallback((item: PaymentCard) => !!value && item.cardId === value?.cardId, [value]);

  const handleItemClick = (item: PaymentCard) => {
    if (item !== value) {
      onChange(item);
    }
    onClose();
  };
  return show ? (
    <Container>
      <Items data-testid={testId ? `${testId}-items` : undefined}>
        {cards.map((card, index) => (
            <MakeItem
              key={card.cardId}
              className={isActive(card) ? 'active' : ''}
              text={card.name}
              type={card.cardType}
              onClick={() => handleItemClick(card)}
              data-testid={index === 0 && testId ? `${testId}-first-item` : undefined}
            />
        ))}
      </Items>
    </Container>
  ) : null;
};

export default CardSelect;
